import styled from 'styled-components'

import { Colors } from 'cio-design-library/design-tokens'
import { Media } from 'builder/styles/media'
import { FontWeights, Typography } from 'builder/styles/typography'
import { WidgetImage } from '../../widget.styles'

export const Image = styled(WidgetImage)``

export const IlustrationContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  position: relative;

  ${Media.Phone`
    align-items: flex-end;
  `}
`

export const IlustrationImageContainer = styled.div`
  position: relative;
  width: 300px;
  height: 169px;
  border-radius: 8px;

  ${Media.Phone`
    width: 200px;
    height: 112px;
  `}
`

export const IlustrationImage = styled.img`
  width: 100%;
  height: 100%;
  border-radius: 8px;
  object-fit: cover;
`

export const IlustrationProgressCircle = styled.div`
  position: absolute;
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background-color: ${Colors.White};
  display: flex;
  justify-content: center;
  align-items: center;
  top: -22px;
  right: -22px;

  ${Media.Phone`
    top: -16px;
    right: -24px;
    width: 56px;
    height: 56px;
  `}
`

export const IlustrationProgressInnerCircle = styled.div<{ percentage: number }>`
  width: 76px;
  height: 76px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: radial-gradient(closest-side, white 79%, transparent 80% 100%),
    conic-gradient(${Colors.Green50} ${({ percentage }) => percentage}%, ${Colors.Neutral10} 0);

  ${Media.Phone`
    width: 52px;
    height: 52px;
  `}
`

export const IlustrationProgressText = styled.p`
  ${Typography.Subhead}
  ${FontWeights.Medium}

  color: ${Colors.Neutral90};
`
